export default __webpack_public_path__ + "static/media/04_photo.a0a2a617.jpeg";